export default "__VITE_ASSET__DiaBxOIn__"